import styled from 'styled-components';

export const Wrapper = styled.div`
    padding: 0 16px;
`;

export const VirtualBackgroundModalVideo = styled.div`
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: ${({ theme }) => theme.root.colors.background.sheetOrModal};
`;
